export const VIDEO_DATA = {
  defaultColor: "#FFFF00",
  end: 0,
  errorColor: "#FFFFFF",
  start: 0,
  steps: [{
    end: 0,
    parts: [{
      hx: 1.1,
      hy: 6,
      lx: 1.1,
      ly: 2,
      part: "elbow"
    }, {
      hx: 1.1,
      hy: 6,
      lx: 1.1,
      ly: 2,
      part: "wrist"
    }, {
      hx: 1.2,
      hy: 6,
      lx: 1.2,
      ly: 2,
      part: "knee"
    }, {
      hx: 1.2,
      hy: 6,
      lx: 1.2,
      ly: 2,
      part: "hip"
    }, {
      hx: 1.2,
      hy: 6,
      lx: 1.2,
      ly: 2,
      part: "ankle"
    }],
    start: 0,
    step: "Step 1"
  }],
  successColor: "#FFFFFF"
}